import createReducer from "../BasicReducer";

export default createReducer('auth/user', {});